import React from 'react'

import StyledSlatOuter from './StyledSlatOuter'
import StyledSlatInner from './StyledSlatInner'

export const PartnersSection = () => {
  return (
    <PartnersSectionStyles id='alianzas'>
      <StyledSlatInner className='partners__inner'>
        <h2 className='partners__title'>Alianzas</h2>
        <div className='partners__grid'>
          <div className='partners__item'></div>
        </div>
      </StyledSlatInner>
    </PartnersSectionStyles>
  )
}

const PartnersSectionStyles = StyledSlatOuter.extend`
  .partners {
    &__inner {
      color: ${({ theme }) => theme.white};
    }

    &__title {
      font-size: 35px;
      text-align: left;
      text-transform: uppercase;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/PartnersSection.js